import { useAeropayUser } from '@iheartjane/data-access/react-query';
import { useMoengageIdentify as useIdentifyToMoengage } from '@iheartjane/tracking';
import { Storage } from '@iheartjane/utils';
import Moe from '@moengage/web-sdk';
import { useCallback, useMemo } from 'react';

import { getJwt } from '@jane/shared/auth';
import { useJaneUser } from '@jane/shared/data-access';
import { getJaneDeviceId } from '@jane/shared/util';

import type { MoeEvent } from './moengageEvents.types';

export const useMoengage = () => {
  const { data: janeUser } = useJaneUser();
  const { data: aeropayUser } = useAeropayUser({
    janeUserId: janeUser?.user?.id ?? null,
    jwt: getJwt(),
  });
  const janeDeviceId = getJaneDeviceId();
  const linkedAccountDate = Storage.get('aeropayLinkDate') || null;

  const commonData = useMemo(
    () => ({
      'Aeropay Account Verified': !!aeropayUser?.bank_accounts.length,
      'Aeropay Link Date': linkedAccountDate,
      'Jane Device Id': janeDeviceId,
      'User Id': janeUser?.user?.id,
    }),
    [aeropayUser, janeUser?.user]
  );

  const moeTrack = useCallback(
    (event: MoeEvent) => {
      // eslint-disable-next-line import-x/no-named-as-default-member
      if (Moe.isMoeLoaded()) {
        // eslint-disable-next-line import-x/no-named-as-default-member
        Moe.trackEvent(event.name, {
          Time: new Date(),
          ...commonData,
          ...event.properties,
        });
      }
    },
    [commonData]
  );

  return { moeTrack };
};

export const useMoengageIdentify = () => {
  const janeUserQuery = useJaneUser();

  useIdentifyToMoengage(
    janeUserQuery.isSuccess ? (janeUserQuery.data.user ?? null) : null
  );
};
